import { IndividualStoreLogPage } from '@/features/payment-management/store-payment-logs/individual-store-logs/IndividualStoreLogPage';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.string(),
  desc: z.boolean(),
});

const individualStoreLogSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z.union([z.string(), z.array(z.string())]).optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  planTypeFilter: z.string().optional(),
  paymentMethodFilter: z.string().optional(),

  page: z.coerce.number().nonnegative().catch(0),
  fetch: z.coerce.number().positive().catch(10),

  storeName: z.string().optional(),
  storeNameJp: z.string().optional(),
});

export const Route = createFileRoute('/(app)/payment-management/store-payment-log/$storeId/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => individualStoreLogSearchSchema.parse(search),
});

function RouteComponent() {
  const { storeId } = Route.useParams();

  return (
    <div className="w-full h-full pb-3 md:pb-5 bg-background">
      <IndividualStoreLogPage storeId={storeId} />
    </div>
  );
}
